/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { DevFailedIngestionDto } from './DevFailedIngestionDto';
import {
    DevFailedIngestionDtoFromJSON,
    DevFailedIngestionDtoFromJSONTyped,
    DevFailedIngestionDtoToJSON,
    DevFailedIngestionDtoToJSONTyped,
} from './DevFailedIngestionDto';
import type { DevIngestionStatus } from './DevIngestionStatus';
import {
    DevIngestionStatusFromJSON,
    DevIngestionStatusFromJSONTyped,
    DevIngestionStatusToJSON,
    DevIngestionStatusToJSONTyped,
} from './DevIngestionStatus';

/**
 * 
 * @export
 * @interface DevEtlOverviewDto
 */
export interface DevEtlOverviewDto {
    /**
     * 
     * @type {Date}
     * @memberof DevEtlOverviewDto
     */
    lastSlotAt: Date;
    /**
     * 
     * @type {DevIngestionStatus}
     * @memberof DevEtlOverviewDto
     */
    lastSlotStatus: DevIngestionStatus;
    /**
     * 
     * @type {DevFailedIngestionDto}
     * @memberof DevEtlOverviewDto
     */
    lastFailure: DevFailedIngestionDto;
}



/**
 * Check if a given object implements the DevEtlOverviewDto interface.
 */
export function instanceOfDevEtlOverviewDto(value: object): value is DevEtlOverviewDto {
    if (!('lastSlotAt' in value) || value['lastSlotAt'] === undefined) return false;
    if (!('lastSlotStatus' in value) || value['lastSlotStatus'] === undefined) return false;
    if (!('lastFailure' in value) || value['lastFailure'] === undefined) return false;
    return true;
}

export function DevEtlOverviewDtoFromJSON(json: any): DevEtlOverviewDto {
    return DevEtlOverviewDtoFromJSONTyped(json, false);
}

export function DevEtlOverviewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevEtlOverviewDto {
    if (json == null) {
        return json;
    }
    return {
        
        'lastSlotAt': (new Date(json['lastSlotAt'])),
        'lastSlotStatus': DevIngestionStatusFromJSON(json['lastSlotStatus']),
        'lastFailure': DevFailedIngestionDtoFromJSON(json['lastFailure']),
    };
}

export function DevEtlOverviewDtoToJSON(json: any): DevEtlOverviewDto {
    return DevEtlOverviewDtoToJSONTyped(json, false);
}

export function DevEtlOverviewDtoToJSONTyped(value?: DevEtlOverviewDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lastSlotAt': ((value['lastSlotAt']).toISOString()),
        'lastSlotStatus': DevIngestionStatusToJSON(value['lastSlotStatus']),
        'lastFailure': DevFailedIngestionDtoToJSON(value['lastFailure']),
    };
}

